import {
  ALL_MECHANICS,
  DEFAULT_BASE_DURATION_MS,
  DEFAULT_ROOM_CONFIG,
  MAX_BASE_DURATION_MS,
  MIN_BASE_DURATION_MS,
  type Mechanic,
  type RoomConfig,
} from '@juegazo/shared';

const STORAGE_LOCAL_CONFIG = 'juegazo.localConfig';
const STORAGE_LEGACY_BASE_DURATION = 'juegazo.localBaseDurationMs';

const clamp = (n: number, min: number, max: number): number => Math.max(min, Math.min(max, n));

export const loadLocalConfig = (): RoomConfig => {
  try {
    const raw = window.localStorage.getItem(STORAGE_LOCAL_CONFIG);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<RoomConfig>;
      const mechanics = Array.isArray(parsed.enabledMechanics)
        ? parsed.enabledMechanics.filter((m): m is Mechanic => (ALL_MECHANICS as readonly string[]).includes(m))
        : null;
      if (
        typeof parsed.totalBombs === 'number' &&
        mechanics !== null &&
        mechanics.length > 0 &&
        typeof parsed.mixedMode === 'boolean' &&
        typeof parsed.baseDurationMs === 'number'
      ) {
        return {
          totalBombs: clamp(Math.floor(parsed.totalBombs), 1, 10),
          enabledMechanics: mechanics,
          mixedMode: parsed.mixedMode,
          baseDurationMs: clamp(parsed.baseDurationMs, MIN_BASE_DURATION_MS, MAX_BASE_DURATION_MS),
        };
      }
    }
  } catch {
    // ignore invalid JSON
  }
  let base = DEFAULT_BASE_DURATION_MS;
  try {
    const raw = window.localStorage.getItem(STORAGE_LEGACY_BASE_DURATION);
    const n = raw ? Number(raw) : NaN;
    if (Number.isFinite(n) && n >= MIN_BASE_DURATION_MS && n <= MAX_BASE_DURATION_MS) base = n;
  } catch {
    // ignore
  }
  return { ...DEFAULT_ROOM_CONFIG, baseDurationMs: base };
};

export const saveLocalConfig = (config: RoomConfig): void => {
  try {
    window.localStorage.setItem(STORAGE_LOCAL_CONFIG, JSON.stringify(config));
  } catch {
    // ignore
  }
};
